<template>
	<v-layout justify-center class="visitUpload_wrap">
		<div class="visitUpload">
			<div class="visitUpload_header px-5" :style="`background-color:${$store.state.PointColor2}`">
				<img src="@/../public/image/QRIcon.png" class="mr-3" style="width:34px" />
				<h2 style="font-size:18px; font-weight:bold; color:#fff">{{ this.$store.state.reservedayData.title }}</h2>
				<v-spacer />
				<v-btn icon @click="close">
					<v-icon class="title-icon" color="white">mdi-close</v-icon>
				</v-btn>
			</div>
			<div class="visitUpload_content pt-10 pr-5 pb-5 pl-5">
				<div style="text-align:center">
					<img style="width:103px;" src="@/assets/images/success_visit.png" />
					<div class="mt-4 mb-10" style="font-size:23px; font-weight:bold; color:#21887A;">방문 예약 정보</div>
				</div>
				<div class="content_wrap pb-6">
					<v-layout v-for="(menu, i) in menuName" :key="i">
						<div class="mt-6 mr-7 ml-6" style="font-size:18px; color:#C2BCC2">{{ menu.title }}</div>
						<div class="mt-6" style="font-size:18px; font-weight:bold" v-if="i === 0">{{ reserveuserData.name }}</div>
						<div class="mt-6" style="font-size:18px; font-weight:bold" v-else>{{ menu.value }}</div>
					</v-layout>
				</div>
				<div class="visit_notice mt-5 ml-2" v-html="bottomNotice"></div>
			</div>
			<div class="text-center mb-4 mx-5" v-if="reserveuserData.state === 'reserve'">
				<v-btn block @click="changeDate" elevation="0" color="primary">예약변경</v-btn>
			</div>
			<v-btn
				class="visitUpload_footer"
				:disabled="menuName[1].value === '' ? true : menuName[2].value === '' ? false : true"
				@click="updateReserveuser"
				>방문등록</v-btn
			>
		</div>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
		<previewEventTalk :setdialog="previewEventTalk" />
		<reservedayModalVisit :setdialog="reserveDialog" :title="placeTitle" :reservedaysData="reservedaysData" />
		<button id="refresh-visit" @click="reserveuser()" style="display: none;"></button>
	</v-layout>
</template>

<script>
import { alertModal5, previewEventTalk } from '@/components/index'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
import reservedayModalVisit from './reservedayModal-visit'
export default {
	components: {
		alertModal5,
		previewEventTalk,
		reservedayModalVisit,
	},
	data() {
		return {
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				dialog1: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			previewEventTalk: {
				dialog: false,
				modalIcon: 'success',
				title: '',
				content: '',
			},
			messageData1: {},
			alertModal: {
				dialog: false,
				text: '',
				reddot: true,
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			placeTitle: '',
			reserveuserData: {},
			reservedaysData: { business: { QRlogo: null } },
			menuName: [
				{ title: '고객명', value: '' },
				{ title: '예약일', value: '' },
				{ title: '방문확인', value: '' },
			],
			bottomNotice: `귀하의 예약정보를 확인하시고 방문시 입구에서 직원 안내에 따라
입장하시기 바랍니다.

아래 <span style="font-weight:bold">[방문등록]</span> 버튼은 고객님께서 예약하신 날짜 및 시간에만 
등록이 가능합니다.
상담신청 및 이벤트 참여 시 고객님의 방문등록 정보가 필요하오니 
예약하신 시간에 방문하시어 직원확인 후 방문등록 하시길 바랍니다.
`,
		}
	},
	created() {
		this.reserveuser()
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		async changeDate() {
			if (this.reservedaysData.business.color) {
				this.$store.state.PointColor7 = this.reservedaysData.business.color
			}
			if (this.reservedaysData.business.btnColor) {
				this.$store.state.PointColor8 = this.reservedaysData.business.btnColor
			}
			let input_boxes
			if (this.reservedaysData.reserveInputBoxId) {
				await this.$store.dispatch('inputboxes', { id: this.reservedaysData.reserveInputBoxId }).then(resData => {
					if (resData.data.inputBoxes[0]) {
						// 시간/달력 검사
						let checkPicker = resData.data.inputBoxes[0].categories.findIndex(e => e.type === 30)
						let checkTime = resData.data.inputBoxes[0].categories.findIndex(e => e.type === 31)

						if (checkPicker === -1) {
							/// 달력 삽입
							resData.data.inputBoxes[0].categories.push({
								type: 30,
								listorder: resData.data.inputBoxes[0].categories.length + 1,

								code: this.reservedaysData.code,
							})
						}
						if (checkTime === -1) {
							// 시간 삽입
							resData.data.inputBoxes[0].categories.push({
								type: 31,
								listorder: resData.data.inputBoxes[0].categories.length + 2,

								code: this.reservedaysData.code,
							})
						}
						this.placeTitle = this.reservedaysData.title
						resData.data.inputBoxes[0].categories.forEach(element => {
							if (element.tag === 'location') {
								if (element.defalutLocation) {
									this.$store.state.searchsel_city1.value = element.defalutLocation.split('_')[0]
									this.loc_firstSelect(element.defalutLocation.split('_')[0])
									if (element.defalutLocation.split('_')[1]) {
										this.loc_twoSelect(element.defalutLocation.split('_')[1])
										this.$store.state.searchsel_city2.value = element.defalutLocation.split('_')[1]
									}
									if (element.defalutLocation.split('_')[2]) {
										this.$store.state.searchsel_city3.value = element.defalutLocation.split('_')[2]
									}
								} else {
									this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
									this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
								}
							}
							if (element.type === 10) {
								element.imgType = element.imgType ? element.imgType : '리스트형'
								element.value = ''
								element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
								element.nowRadioValue = ''
								element.etc = ''
								if (element.detailImg) {
									element.detailImg.url = process.env.VUE_APP_BACKEND_URL + element.detailImg.url
								}
								if (element.previewImg) {
									element.previewImg.url = process.env.VUE_APP_BACKEND_URL + element.previewImg.url
								}
								element.category_details.forEach(detail => {
									if (detail.detailImg) {
										detail.detailImg.url = process.env.VUE_APP_BACKEND_URL + detail.detailImg.url
									}
									if (detail.previewImg) {
										detail.previewImg.url = process.env.VUE_APP_BACKEND_URL + detail.previewImg.url
									}
								})
							} else if (element.type === 11) {
								element.imgType = element.imgType ? element.imgType : '리스트형'
								if (element.detailImg) {
									element.detailImg.url = process.env.VUE_APP_BACKEND_URL + element.detailImg.url
								}
								if (element.previewImg) {
									element.previewImg.url = process.env.VUE_APP_BACKEND_URL + element.previewImg.url
								}
								element.category_details.forEach(detail => {
									if (!element.items) {
										element.items = []
									}
									element.items.push({
										value: '',
										label: detail.detailname,
										color: '',
										class: '',
										errorMessage: '',
										hideDetail: true,
										detailcode: detail.detailcode,
									})
									if (detail.detailImg) {
										detail.detailImg.url = process.env.VUE_APP_BACKEND_URL + detail.detailImg.url
									}
									if (detail.previewImg) {
										detail.previewImg.url = process.env.VUE_APP_BACKEND_URL + detail.previewImg.url
									}
								})
							} else if (element.type === 12) {
								element.items = {
									label: '',
									value: '',
									errorMessage: '',
									hideDetail: true,
									outlined: true,
									color: this.$store.state.PointColor7,
								}
							} else if (element.type === 20) {
								element.items = {
									value: '',
									maxlength: '255',
									outlined: true,
									autofocus: false,
									hideDetail: false,
									errorMessage: '',
									color: this.$store.state.PointColor7,
								}
							}
						})
						input_boxes = resData.data.inputBoxes[0]
					}
				})
			} else {
				this.placeTitle = this.reservedaysData.title
				input_boxes = {
					categories: [
						{
							type: 30,
							listorder: 1,
							code: this.reservedaysData.code,
						},
						{
							type: 31,
							listorder: 2,
							code: this.reservedaysData.code,
						},
					],
				}
			}
			this.$store.state.reserveusersData = this.reserveuserData
			this.$store.state.reserveuserId = this.reserveuserData.id
			this.$store.state.reserveUserData = {
				reserveCreateDate: this.reserveuserData.created_at,
				reserveUpdateDate: this.reserveuserData.updated_at,
				name: this.reserveuserData.name,
				reservedDate: this.reserveuserData.rdate,
			}
			this.$store.state.reservedayInputBox = input_boxes
			this.$store.state.maxcount = this.reservedaysData.maxcount
			this.$store.state.nodaySetting = this.reservedaysData.nodaySetting
			this.$store.state.timeRange = this.reservedaysData.timeRange
			this.$store.state.startDate = this.$moment(this.reservedaysData.sdate)
				.add(9, 'hours')
				.format('YYYY-MM-DD')
			this.$store.state.endDate = this.$moment(this.reservedaysData.edate)
				.add(9, 'hours')
				.format('YYYY-MM-DD')
			this.reserveDialog.dialog = true
			this.reserveDialog.step1 = true
			this.reserveDialog.step2 = false
			this.reserveDialog.step3 = false
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		close() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		reserveuser() {
			const data = {
				id: this.$route.params.id,
				status: 1,
			}
			const data1 = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data1).then(resReserveDay => {
				this.reservedaysData = resReserveDay.data.reservedays[0]
				this.$store.dispatch('events', { id: Number(this.reservedaysData.event) }).then(res => {
					this.reservedaysData.event = res.data.events[0]
				})
				this.$store.state.reservedayData = resReserveDay.data.reservedays[0]
				this.$store.dispatch('reserveuser', data).then(res => {
					this.reserveuserData = res.data.reserveuser
					this.reserveuserData.business = resReserveDay.data.reservedays[0].business
					if (this.reserveuserData.status === 2) {
						if (!alert('예약취소된 고객 입니다.')) this.close()
					}
					this.menuName[1].value = this.$moment(res.data.reserveuser.rdate)
						.subtract(9, 'h')
						.format('YYYY-MM-DD HH:mm')
					if (res.data.reserveuser.state === 'visit')
						this.menuName[2].value = this.$moment(res.data.reserveuser.updated_at).format('YYYY-MM-DD HH:mm')
					else this.menuName[2].value = ''
				})
			})
		},
		creaetSendMessage() {
			this.$store.state.loading = true

			const data2 = {
				tplCode: this.$store.state.reservedayData.tplCode[14],
			}
			this.$store.dispatch('messages', data2).then(res => {
				if (res.data.messages.length > 0) {
					this.messageData1 = res.data.messages[0]

					let reserveDayurl = `${location.protocol}//${location.hostname}/reserve_day/${
						this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE
					}`
					const now = new Date()
					const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
					if (this.messageData1.message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
						this.messageData1.message = this.messageData1.message.replace(/#{고객명}/g, this.reserveuserData.name)
						this.messageData1.message = this.messageData1.message.replace(/#{예약신청일시}/g, today)
						this.messageData1.message = this.messageData1.message.replace(/#{관람신청일시}/g, today)
						this.messageData1.message = this.messageData1.message.replace(/#{상담신청일시}/g, today)
						this.messageData1.message = this.messageData1.message.replace(/#{예약URL}/g, reserveDayurl)
						this.messageData1.message = this.messageData1.message.replace(/#{대표번호}/g, this.$store.state.reservedayData.callerNumber)
					}
					if (this.messageData1.button) {
						const buttonsData = JSON.parse(this.messageData1.button).button
						buttonsData.forEach(element => {
							if (element.linkMo) {
								element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.reserveuserData.phone)
								element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.reserveuserData.phone)
								element.linkMo = element.linkMo.replace(
									/#{분양정보pdf}/g,
									this.reserveuserData.business.alertTalkSalesInformation?.url.replace('/uploads', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{분양정보pdf}/g,
									this.reserveuserData.business.alertTalkSalesInformation?.url.replace('/uploads', ''),
								)
								if (this.reserveuserData.business.alertTalkSubscriptionInformation?.url) {
									element.linkMo = element.linkMo.replace(
										/#{청약안내pdf}/g,
										this.reserveuserData.business.alertTalkSubscriptionInformation?.url.replace('/uploads', ''),
									)
									element.linkPc = element.linkPc.replace(
										/#{청약안내pdf}/g,
										this.reserveuserData.business.alertTalkSubscriptionInformation?.url.replace('/uploads', ''),
									)
								}
								element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reserveuserData.business.alertTalkTalk)
								element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reserveuserData.business.alertTalkTalk)
								element.linkMo = element.linkMo.replace(/#{url}/g, this.reserveuserData.business.alertTalkHomepage)
								element.linkPc = element.linkPc.replace(/#{url}/g, this.reserveuserData.business.alertTalkHomepage)
							}
						})
						this.messageData1.button = JSON.stringify(buttonsData)
					}
					const data = {
						// 필수값

						code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
						sender: this.messageData1.smssender,
						senderkey: this.messageData1.senderkey,
						tpl_code: this.messageData1.tplCode,
						receiver_1: this.reserveuserData.phone,
						subject_1: this.messageData1.tplCodeStr,
						message_1: this.messageData1.message,
						recvname_1: this.reserveuserData.name,
						failover: 'Y',
						fsubject_1: this.messageData1.tplCodeStr,
						fmessage_1: this.messageData1.message,
						button_1: this.messageData1.button ? this.messageData1.button : '[]',
						pay: this.reserveuserData.business?.id,
					}
					this.$store.dispatch('createSendMessage', data).then(() => {
						this.$store.state.loading = false
					})
				} else {
					this.$store.state.loading = false
				}
			})
		},
		createEventJoin() {
			const data = {
				code: this.reservedaysData.event.code,
				dropout: false,
			}
			this.$store.dispatch('eventJoins', data).then(res => {
				let map = []
				let priceProductCount = 0
				let useYnFalseCount = 0
				for (let index2 = 0; index2 < this.reservedaysData.event.priceList.length; index2++) {
					if (this.reservedaysData.event.priceList[index2].useYn) {
						priceProductCount += this.reservedaysData.event.priceList[index2].winnerNumber
						for (let index3 = 0; index3 < this.reservedaysData.event.priceList[index2].winnerNumber; index3++) {
							map.push({
								auto: this.reservedaysData.event.priceList[index2].auto ? this.reservedaysData.event.priceList[index2].auto : null,
								product: this.reservedaysData.event.priceList[index2].product,
								winnder: true,
							})
						}
					} else useYnFalseCount += this.reservedaysData.event.priceList[index2].winnerNumber
				}
				for (
					let index = 0;
					index <
					this.reservedaysData.event.maxcount - priceProductCount - useYnFalseCount - res.data.eventJoins.filter(x => !x.winner).length;
					index++
				) {
					map.push({
						product: '',
						winnder: false,
					})
				}
				for (let index = 0; index < res.data.eventJoins.filter(x => x.winner).length; index++) {
					const eventJoinIndex = map.map(x => x.product).indexOf(res.data.eventJoins.filter(x => x.winner)[index].winnterProduct)
					map.splice(eventJoinIndex, 1)
				}
				let data2 = {}
				const mapData = this.randomItem(this.shuffle(map))
				if (mapData) {
					if (mapData.winnder) {
						const now = new Date()
						const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
						let alertTalkmessage = null
						if (this.reservedaysData.event.message) {
							let alertTalkmessage = this.reservedaysData.event.message.message
							alertTalkmessage = alertTalkmessage.replace(/#{사업지명}/g, this.reservedaysData.event.title)
							alertTalkmessage = alertTalkmessage.replace(/#{고객명}/g, this.reserveuserData.name)
							alertTalkmessage = alertTalkmessage.replace(/#{이벤트당첨일시}/g, today)
							alertTalkmessage = alertTalkmessage.replace(/#{상품명}/g, mapData.product)
							alertTalkmessage = alertTalkmessage.replace(/#{대표번호}/g, this.reservedaysData.event.callerNumber)
							this.reservedaysData.event.message.message = alertTalkmessage
						}
						data2 = {
							name: this.reserveuserData.name,
							phone: this.reserveuserData.phone,
							event: this.reservedaysData.event.id,
							eventTitle: this.reservedaysData.event.title,
							winner: true,
							winnterTitle: mapData.product,
							winnterProduct: mapData.product,
							alertTalkmessage: alertTalkmessage,
							code: this.reservedaysData.event.code,
							locationData: null,
							// this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
							// 	? this.$store.state.searchsel_city1.value +
							// 	  '_' +
							// 	  this.$store.state.searchsel_city2.value +
							// 	  '_' +
							// 	  this.$store.state.searchsel_city3.value
							// 	: '',
							marketing: this.$store.state.check5.value,
							receiveInformation: this.$store.state.check6.value,
						}
						if (mapData.auto) {
							data2.receipt = '수령'
							data2.receiptDate = new Date(new Date().setHours(new Date().getHours() + 9))
						}
					} else {
						data2 = {
							name: this.reserveuserData.name,
							phone: this.reserveuserData.phone,
							event: this.reservedaysData.event.id,
							eventTitle: this.reservedaysData.event.title,
							code: this.reservedaysData.event.code,
							locationData: null,
							// this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
							// 	? this.$store.state.searchsel_city1.value +
							// 	  '_' +
							// 	  this.$store.state.searchsel_city2.value +
							// 	  '_' +
							// 	  this.$store.state.searchsel_city3.value
							// 	: '',
							marketing: this.$store.state.check5.value,
							receiveInformation: this.$store.state.check6.value,
						}
					}
					this.$store.dispatch('createEventJoin', data2).then(() => {
						if (this.reservedaysData.event.endLink) this.previewEventTalk.endLink = this.reservedaysData.event.endLink
						if (mapData.winnder) {
							this.previewEventTalk.title = '이벤트 당첨안내'
							this.previewEventTalk.content = this.reservedaysData.event.winnerMessage.replace('{상품명}', mapData.product)
							if (this.reservedaysData.event.message) this.creaetSendMessage_event()
						} else {
							this.previewEventTalk.title = '이벤트 결과안내'
							this.previewEventTalk.content = this.reservedaysData.event.joinMessage
						}
						this.previewEventTalk.dialog = true
						this.$store.state.loading = false
					})
				} else {
					this.$store.state.loading = false
					this.startDialog.dialog = false
					this.alertModal2.text = '본 이벤트는 종료되었습니다.'
					this.alertModal2.dialog = true
				}
			})
		},
		creaetSendMessage_event() {
			const data = {
				// 필수값

				code: this.reservedaysData.event.code,
				tpl_code: this.reservedaysData.event.message.tplCode,
				sender: this.reservedaysData.event.message.smssender,
				senderkey: this.reservedaysData.event.message.senderkey,
				receiver_1: this.reserveuserData.phone,
				subject_1: this.reservedaysData.event.message.tplCodeStr,
				message_1: this.reservedaysData.event.message.message,
				recvname_1: this.reserveuserData.name,
				failover: 'Y',
				fsubject_1: this.reservedaysData.event.message.tplCodeStr,
				fmessage_1: this.reservedaysData.event.message.message,
				button_1: this.reservedaysData.event.message.button ? this.reservedaysData.event.message.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(() => {})
		},
		eventClick() {
			if (
				this.$moment(this.$moment().format('YYYY-MM-DD')).isBetween(
					this.$moment().format('YYYY-MM-DD'),
					this.reservedaysData.event.end.substring(0, 10),
					undefined,
					'[]',
				)
			) {
				if (
					this.$moment(this.$moment().format('YYYY-MM-DD')).isBetween(
						this.reservedaysData.event.start.substring(0, 10),
						this.$moment().format('YYYY-MM-DD'),
						undefined,
						'[]',
					)
				) {
					this.$store.state.loading = true
					const data = {
						code: this.reservedaysData.event.code,
						dropout: false,
					}
					this.$store.dispatch('eventJoinCount', data).then(res => {
						let reserveAmount = res
						this.$store.state.loading = false

						let useYnFalseCount = 0
						for (let index2 = 0; index2 < this.reservedaysData.event.priceList.length; index2++) {
							if (!this.reservedaysData.event.priceList[index2].useYn) {
								useYnFalseCount += this.reservedaysData.event.priceList[index2].winnerNumber
							}
						}
						if (reserveAmount >= this.reservedaysData.event.maxcount - useYnFalseCount) {
							this.alertModal2.text = '본 이벤트는 종료되었습니다.'
							this.alertModal2.dialog = true
						} else {
							const data2 = {
								phone: this.reserveuserData.phone,
								code: this.reservedaysData.event.code,
								dropout: false,
							}
							this.$store.dispatch('eventJoinCount', data2).then(res => {
								// eventJoins에 입력한 정보의 참가자가 있는 경우
								if (!this.reservedaysData.event.duplicate) {
									if (res) {
										this.alertModal2.text = '고객님은 해당 이벤트에 이미 참여하셨습니다. (중복참여 불가)'
										this.alertModal2.dialog = true
									} else {
										this.createEventJoin()
									}
								} else {
									this.createEventJoin()
								}
							})
						}
					})
				}
			}
		},
		updateReserveuser() {
			if (this.$moment(this.$moment().format('YYYY-MM-DD 00:00:00')).add(1, 'd') > this.$moment(this.menuName[1].value)) {
				const data = {
					id: this.$route.params.id,
					state: 'visit',
				}
				this.$store.dispatch('updateReserveuser', data).then(res => {
					this.menuName[2].value = this.$moment(res.data.updateReserveuser.reserveuser.updated_at).format('YYYY-MM-DD HH:mm')
					// this.creaetSendMessage()
					// if (this.reservedaysData.event) this.eventClick()
				})
			} else {
				this.alertModal.dialog = true
				this.alertModal.text = `고객님께서 예약하신 날짜는 ${this.$moment(this.menuName[1].value).format('YYYY-MM-DD HH:mm')} 입니다.
예약하신 날짜에만 방문등록이 가능합니다.`
			}
		},
	},
}
</script>

<style lang="scss">
.visitUpload_wrap {
	background: #fff;
	width: 100%;
}
.visitUpload {
	width: 446px;
}
.visitUpload_header {
	border-top-left-radius: 15px;
	border-top-right-radius: 15px;
	background: #323153;
	color: #fff;
	height: 70px;
	display: flex;
	align-items: center;
}
.content_wrap {
	border-top: 1px dashed #c2bcc2;
	border-bottom: 1px dashed #c2bcc2;
}
.visit_notice {
	font-size: 13px;
	color: #8b8b8b;
	text-align: start;
	white-space: pre-line;
}
.visitUpload_footer {
	width: 100%;
	border-radius: 0 0 15px 15px;
	.v-btn__content {
		color: #fff;
		font-size: 18px;
		font-weight: bold;
	}
}
.visitUpload_footer.v-btn--is-elevated {
	box-shadow: none;
}
.visitUpload_footer:not(.v-btn--round).v-size--default {
	height: 77px;
	background: #ffae28;
}
</style>
